import React, { Component, createRef } from "react";
import { Drawer, Form, Input, Button } from "antd";
import type { FormInstance } from "antd/es/form";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import PermissionWrapper from "shared/components/PermissionWrapper";


interface AddSettingHandlers {
  showDrawer: () => void;
  closeDrawer: () => void;
  onFinish: (values: any) => void;
}

interface AddSettingValues {
  visible: boolean;
  form: FormInstance<any>;
}

interface AddSettingProps {
  hasCreateAccess: boolean;
  handlers: AddSettingHandlers;
  values: AddSettingValues;
}

export default class AddApplicationSetting extends Component<AddSettingProps> {
  formRef = createRef<FormInstance>();

  render() {
    const { handlers, values } = this.props;
    const { visible, form } = values;
    const { showDrawer, closeDrawer, onFinish } = handlers;

    return (
      <>
        <PermissionWrapper
          hasPermissions={this.props.hasCreateAccess}
          children={
            <Button type="primary" onClick={showDrawer}>
              {
                !visible ? (
                  <PlusCircleOutlined style={{ fontSize: "15px" }} />
                ) : (
                  <MinusCircleOutlined style={{ fontSize: "15px" }} />
                )
              } Add Setting
            </Button>
          }
        />

        <Drawer
          title="Add Application Setting"
          open={visible}
          width={480}
          onClose={closeDrawer}
          className="manage-pages-drawer add-app-setting-drawer"
        >
          <Form
            form={form}
            ref={this.formRef}
            layout="vertical"
            onFinish={(vals) => {
              onFinish(vals);
              closeDrawer();
            }}
          >
            <Form.Item
              name="key"
              label="Key"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="value"
              label="Value"
              rules={[{ required: true }]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>
            <Form.Item
              name="category"
              label="Type"
            >
              <Input />
            </Form.Item>
            <Form.Item name="description" label="Description (Validate Message or etc.)">
              <Input.TextArea rows={2} />
            </Form.Item>
            <Form.Item name="reason" label="Reason">
              <Input.TextArea rows={2} />
            </Form.Item>

            <Button type="primary" htmlType="submit" block>
              Save
            </Button>
          </Form>
        </Drawer>
      </>
    );
  }
}
